<template>
  <div class="box">
    <div class="box2">
      <div class="complaintInformation">
        <div class="complaintNumber border_bottom">
          <div class="left">投诉单号</div>
          <div class="right">{{itemList.mainComplainNumber}}</div>
        </div>
        <div class="complaintObject border_bottom">
          <div class="left">操作人</div>
          <div class="right">{{checkPerson.depts[0].orgName}}-{{checkPerson.userInfo.name}}</div>
        </div>
      </div>
      <div class="remark">
        <div class="titleName">原因说明</div>
        <div class="notAccepted">
          <van-field placeholder="请填写原因..." type="textarea" maxlength="200" @input="change" v-model="value"/>
          <span class="total">{{currentTotal}}/200</span>
        </div>
      </div>
      <div class="btn">
        <div class="submit">
          <van-button type="primary" @click="sent">不通过</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import util from '../../../../utils/common'
    import api from '../../../../service/modules/complaintApis';
    export default {
        data () {
            return {
                checkPerson: this.$store.state.complaint.userInfo || util.getJsonLocal('userInfoComplaint'),
                currentTotal: 0,
                value: '',
                itemList: util.getJsonLocal('item'),
                isback: this.$store.state.complaint.isBackDetail || util.getJsonLocal('isBack'),
                flag: false
                // isShowBtn: false
            };
        },
        created () {

        },
        methods: {
            change () {
                this.currentTotal = this.value.trim().length;
            },
            sent () {
                if (this.value.trim().length === 0) {
                    this.$Toast('请填写原因');
                    return;
                }
                var params = {
                    // data:{
                     
                    // }
                    'mainComplainNumber': this.itemList.mainComplainNumber,
                     'complainNumber':this.itemList.complainNumber,
                     'id': this.itemList.id,
                     'subId': this.itemList.subId,
                     'subPid': this.itemList.subPid,
                     'reason': this.value.trim()
                    
                }
                // this.isShowBtn = true;
                if (this.flag === false) {
                  this.flag = true;
                  api.worker.verifyDisagree(params).then((res) => {
                      if (res.ret === 0) {
                          this.$Toast('操作成功');
                          this.$router.back();
                          // this.isShowBtn = false;
                      }
                  })
                }
            }
        }
    };
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  padding: 14px;
  background-color: #f4f3f3;
  box-sizing: border-box;
  height: 100%;
  .box2 {
    width: 100%;
    padding: 14px;
    background-color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    .complaintInformation {
      width: 100%;
      .complaintNumber,
      .complaintObject,
      .whetherApplyAplitting {
        display: flex;
        // height: 50px;
        line-height: 50px;
        .left {
          float: left;
          width: 20%;
          text-align: left;
          color: #aaa;
        }
        .right {
          float: left;
          width: 80%;
          text-align: right;
          // word-break: break-all;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .complaintNumber {
        .right {
          color: blue;
        }
      }
    }
    .remark {
      width: 100%;
      margin-top: 20px;
      padding-bottom: 20px;
      .titleName {
        color: #aaa;
        text-align: left;
      }
      .notAccepted {
        margin-top: 14px;
        position: relative;
        .van-cell {
          font-size: 12px;
          background: #efeded;
          border-radius: 7px;
        }
        .total{
              position: absolute;
              bottom:6px;
              right:6px;
          }
      }
      .addCommandCenter {
          width: 70%;
          margin-left: 15%;
          font-size: 14px;
          height: 45px;
          line-height: 45px;
          color: #bbb;
          border: #ccc dashed 1px;
          text-align: center;
          margin-top: 15px;
      }
    }
    .companyName {
      height: 50px;
      line-height: 50px;
    }
    .emergencyLevel {
      width: 100%;
      height: 50px;
      line-height: 50px;
    }
    .btn {
      margin-top: 14px;
      .van-button {
        width: 100%;
        border-radius: 7px;
      }
      .back {
        .van-button {
          color: #bdb8b8;
        }
        .van-button--plain {
          background-color: #efeded;
        }
      }
    }
    .border_bottom {
      border-bottom: 1px solid #eee;
    }
  }
}
</style>
